module.exports = __webpack_public_path__ + "static/media/SecondContent.845ede7e.png";